/**
 * Sort order and grouping from Befundparameter_1220 (shortName + label + Hinweise/Gruppe).
 * Generated enrichment: `befundparameterEnrichment.json` via `scripts/generate-befundparameter-mapping.py`
 */

import enrichment from "./befundparameterEnrichment.json";

export type BloodpanelSortEntry = {
    name: string;
    unit?: string;
    group: string;
    shortName?: string;
    label?: string;
    sortIndex: number;
    excluded?: boolean;
    aliases?: string[];
};

export const OTHER_VALUES_GROUP_KEY = "other_values";

// IMPORTANT: Do not accept backend grouping names; only allow the groups as defined in
// "Vorgeschlagene Gruppierung" (see Wertezuordnung.csv).
export const BLOODPANEL_GROUP_ORDER = [
    "Senkung",
    "Blutbild",
    "Glucose",
    "Niere",
    "Leber",
    "Bauchspeicheldrüsewerte",
    "Fette",
    "Elektrolyte",
    "Eisen",
    "Hormone",
    "Tumormarker",
    "Serologie",
    "Harn",
] as const as readonly string[];

export const BLOODPANEL_SORT_ENTRIES: BloodpanelSortEntry[] = enrichment.entries.map((entry) => ({
    name: entry.name,
    unit: entry.unit ?? undefined,
    group: entry.group,
    shortName: entry.shortName ?? undefined,
    label: entry.label ?? undefined,
    sortIndex: entry.sortIndex,
    excluded: entry.excluded || undefined,
    aliases: entry.aliases?.length ? entry.aliases : undefined,
}));
